import type { ChangeEvent, FC } from 'react';
import { useEffect, useState } from 'react';
import { Picture, Button } from '@ui';
import { observer } from 'mobx-react';
import { autorun } from 'mobx';
import { validationEmail } from '@utils/validation';
import SuccessModalWithTimer from '@components/Modals/SuccessModalWithTimer';
import { Link } from '@compat/router';
import API from '@api';
import { useMutation } from '@tanstack/react-query';
import {
  subscriptionShrimp,
  subscriptionLemon,
  subscriptionGrass
} from '@images';
import icons from '@icons';
import { useStores } from '@root/src/stores';
import './index.scss';

const {
  close: { midGrey: closeOutlineMidGrey }
} = icons.Outline;

interface SubscriptionProps {
  isModal?: boolean;
  isBanner?: boolean;
}

const Subscription: FC<SubscriptionProps> = observer(
  ({ isModal, isBanner }) => {
    const { userStore } = useStores();
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [successModalText, setSuccessModalText] = useState('');
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    const [isShowSubscriptionFooter, setIsShowSubscriptionFooter] =
      useState(true);

    useEffect(() => {
      const disposer = autorun(() => {
        const { user } = userStore;
        setEmail(user?.email || '');
      });
      return () => {
        if (disposer) {
          disposer();
        }
      };
    }, [userStore]);

    const changeEmail = (e: ChangeEvent<HTMLInputElement>): void => {
      setEmail(e.target.value);
    };

    const subscribeMutation = useMutation({
      mutationFn: (subscribeEmail: string) =>
        API.addSubscriberTemp({ subscribeEmail }),
      onSuccess: res => {
        setEmail('');
        setSuccessModalText(
          res.addSubscriberTemp.result
            ? 'Вы успешно подписались!'
            : 'Вы уже подписаны!'
        );
        setShowSuccessModal(true);
        onCloseSubscription();
      },
      onError: console.log
    });

    const addSubscriber = (): void => {
      let error = '';

      if (!validationEmail(email)) {
        error = 'Некорректный email';
      }
      setError(error);

      if (error) {
        return;
      }

      subscribeMutation.mutate(email);
    };

    const closeSuccessModal = (): void => {
      setShowSuccessModal(false);
    };

    // const changeToSuccessModal = () => {
    //   setShowCallbackModal(false);
    //   setShowSuccessModal(true);
    //   setTitle('Спасибо !');
    //   setSuccessModalText('Мы перезвоним вам в самое ближайшее время');
    // };

    const onCloseSubscription = (): void => {
      setIsShowSubscriptionFooter(false);
      localStorage.setItem('isShowSubscriptionFooter', JSON.stringify('true'));
    };

    if (!isShowSubscriptionFooter && !isModal) {
      return null;
    }
    return (
      <>
        {showSuccessModal && (
          <SuccessModalWithTimer
            closeModal={closeSuccessModal}
            title='Внимание!'
            text={successModalText}
          />
        )}

        <div
          className={`subscription${isModal ? ' isModal' : ''}${
            isBanner ? ' isBanner' : ''
          }`}
        >
          <div className='pictures-container-shrimp'>
            <Picture
              className='shrimp-picture'
              icon={subscriptionShrimp}
              height='100'
            />
          </div>
          <div className='pictures-container-lemon'>
            <Picture
              className='lemon-picture'
              icon={subscriptionLemon}
              height='118'
            />
          </div>
          <div className='pictures-container-grass'>
            <Picture
              className='grass-picture'
              icon={subscriptionGrass}
              height='140'
            />
          </div>

          {!isModal && (
            <Picture
              pictureClassName='subscriptionCross'
              icon={closeOutlineMidGrey}
              onClick={onCloseSubscription}
              height='24'
              width='24'
            />
          )}
          <div className='subscription-text'>
            <div className='title'>
              Скидка 500 ₽ <br className='hidden allMd:block' /> за подписку на
              рассылку
            </div>
            <div className='text'>Действует при покупке от 5000 ₽</div>
          </div>
          <div className='subscription-buttons'>
            <input
              type='email'
              value={email || ''}
              className={error ? 'input input-warning' : 'input'}
              placeholder='E-mail'
              onChange={changeEmail}
            />

            <Button
              text={'Подписаться'}
              rank='primary'
              size='medium'
              colour='red'
              onClick={addSubscriber}
              fullWidth
            />

            <div className='text'>
              Нажимая «Подписаться», вы соглашаетесь с{' '}
              <Link to={'/confidential'}> политикой конфиденциальности</Link>
            </div>
          </div>
        </div>
      </>
    );
  }
);

export default Subscription;
